import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function ServiceCenterModal({ isOpen, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [TabType, setTabType] = useState(0);

    const [First, setFirst] = useState(true);

    const [QAStartIndex, setQAStartIndex] = useState(1);
    const [FAQStartIndex, setFAQStartIndex] = useState(1);   

    const [QATotalCount, setQATotalCount] = useState(-1);
    const [FAQTotalCount, setFAQTotalCount] = useState(-1);

    useEffect(() => {
        if (isOpen && First) {
            RequestNotice(1);
            setFirst(false);
        }
    }, [isOpen, First]);

    const Close = () =>{
        onClose();

        setTabType(0);
        
        setQAStartIndex(1);
        setFAQStartIndex(1);
        setQATotalCount(-1);
        setFAQTotalCount(-1);

        dispatch({type:'UpdateNoticeDataArray', Log:[]});  
        dispatch({type:'UpdateGuideDataArray', Log:[]});  
        dispatch({type:'UpdateTermsDataArray', Log:[]});  
        dispatch({type:'UpdateFAQDataArray', Log:[]});  
        dispatch({type:'UpdateQADataArray', Log:[]});  

        setFirst(true);
    }

    function ChangeView(view)
    {
        if(TabType === view)
        {
            return;
        }

        setTabType(view);

        setQAStartIndex(1);
        setFAQStartIndex(1);
        setQATotalCount(-1);
        setFAQTotalCount(-1);

        dispatch({type:'UpdateNoticeDataArray', Log:[]});  
        dispatch({type:'UpdateGuideDataArray', Log:[]});  
        dispatch({type:'UpdateTermsDataArray', Log:[]});  
        dispatch({type:'UpdateFAQDataArray', Log:[]});  
        dispatch({type:'UpdateQADataArray', Log:[]});  

        if(view === 0)
        {
            RequestNotice();
        }
        else if(view === 1)
        {
            RequestGuide();
        }
        else if(view === 2)
        {
            RequestQA(1);
        }
        else if(view === 3)
        {
            RequestFAQ(1);
        }
        else if(view === 4)
        {
            RequestTerms();
        }        
    }

    const RequestNotice = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'GetNoticeList/GetNoticeList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateNoticeDataArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    function GetNoticeNo(index)
    {
        if(state.notice_data_array === undefined || state.notice_data_array.length <= index)
        {
            return "";
        }

        return index + 1;
    }

    function GetNoticeTitle(index)
    {
        if(state.notice_data_array === undefined || state.notice_data_array.length <= index)
        {
            return "";
        }

        return state.notice_data_array[index].title;
    }

    function GetNoticeRegisterTime(index)
    {
        if(state.notice_data_array === undefined || state.notice_data_array.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.notice_data_array[index].create_at_time);
    }

    const RequestGuide = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'GetGuideList/GetGuideList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateGuideDataArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    
    
    function GetGuideNo(index)
    {
        if(state.guide_data_array === undefined || state.guide_data_array.length <= index)
        {
            return "";
        }

        return index + 1;
    }

    function GetGuideTitle(index)
    {
        if(state.guide_data_array === undefined || state.guide_data_array.length <= index)
        {
            return "";
        }

        return state.guide_data_array[index].title;
    }

    function GetGuideRegisterTime(index)
    {
        if(state.guide_data_array === undefined || state.guide_data_array.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.guide_data_array[index].create_at_time);
    }

    const RequestTerms = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'GetTermsList/GetTermsList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateTermsDataArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    

    function GetTermsNo(index)
    {
        if(state.terms_data_array === undefined || state.terms_data_array.length <= index)
        {
            return "";
        }

        return index + 1;
    }

    function GetTermsTitle(index)
    {
        if(state.terms_data_array === undefined || state.terms_data_array.length <= index)
        {
            return "";
        }

        return state.terms_data_array[index].title;
    }

    function GetTermsRegisterTime(index)
    {
        if(state.terms_data_array === undefined || state.terms_data_array.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.terms_data_array[index].create_at_time);
    }

    const RequestQA = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'GetQAList/GetQAList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 10}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    setQATotalCount(data.total_count);
                    dispatch({type:'UpdateQADataArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };        

    function GetQANo(index)
    {
        if(state.qa_data_array === undefined || state.qa_data_array.length <= index)
        {
            return "";
        }

        var convertIndex = ((QAStartIndex - 1) * 10) + index;
        if(QATotalCount <= convertIndex)
        {
            return'';
        }

        return convertIndex + 1;
    }

    function GetQATitle(index)
    {
        if(state.qa_data_array === undefined || state.qa_data_array.length <= index)
        {
            return "";
        }

        return state.qa_data_array[index].title;
    }

    function GetQARegisterTime(index)
    {
        if(state.qa_data_array === undefined || state.qa_data_array.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.qa_data_array[index].create_at_time);
    }

    function GetQAStatus(index)
    {
        if(state.qa_data_array === undefined || state.qa_data_array.length <= index)
        {
            return "";
        }

        return state.qa_data_array[index].status === 0 ? '답변대기' : '답변완료';
    }

    const RequestFAQ = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'GetFAQList/GetFAQList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 10}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    setFAQTotalCount(data.total_count);
                    dispatch({type:'UpdateFAQDataArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    

    function GetFAQNo(index)
    {
        if(state.faq_data_array === undefined || state.faq_data_array.length <= index)
        {
            return "";
        }

        var convertIndex = ((FAQStartIndex - 1) * 10) + index;
        if(FAQTotalCount <= convertIndex)
        {
            return'';
        }

        return convertIndex + 1;
    }

    function GetFAQTitle(index)
    {
        if(state.faq_data_array === undefined || state.faq_data_array.length <= index)
        {
            return "";
        }

        return state.faq_data_array[index].title;
    }

    function GetFAQRegisterTime(index)
    {
        if(state.faq_data_array === undefined || state.faq_data_array.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.faq_data_array[index].create_at_time);
    }

    function QAStartIndexClick(index)
    {
        if(QAStartIndex === index)
        {
            return;
        }

        if(QATotalCount === -1)
        {
            return;
        }
    
        var convertIndex = Math.ceil(QATotalCount / 10);
        if(convertIndex < index)
        {
            return;
        }

        setQAStartIndex(index);
        RequestQA(index);
    }

    function GetQAStartIndexCursor(index)
    {
        if(QAStartIndex === index)
        {
            return false;
        }

        if(QATotalCount === -1)
        {
            return false;
        }
    
        var convertIndex = Math.ceil(QATotalCount / 10);
        if(convertIndex < index)
        {
            return false;
        }

        return true;
    }

    function FAQStartIndexClick(index)
    {
        if(FAQStartIndex === index)
        {
            return;
        }

        if(FAQTotalCount === -1)
        {
            return;
        }
    
        var convertIndex = Math.ceil(FAQTotalCount / 10);
        if(convertIndex < index)
        {
            return;
        }

        setFAQStartIndex(index);
        RequestFAQ(index);
    }

    function GetFAQStartIndexCursor(index)
    {
        if(FAQStartIndex === index)
        {
            return false;
        }

        if(FAQTotalCount === -1)
        {
            return false;
        }
    
        var convertIndex = Math.ceil(FAQTotalCount / 10);
        if(convertIndex < index)
        {
            return false;
        }

        return true;
    }

    function GetNoticeClick(index)
    {
        if(state.notice_data_array === undefined || state.notice_data_array.length <= index)
        {
            return false;
        }

        return true;
    }

    function NoticeClick(index)
    {
        if(state.notice_data_array === undefined || state.notice_data_array.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType1', View:true, Type:0, No:state.notice_data_array[index].no});
    }

    function GetGuideClick(index)
    {
        if(state.guide_data_array === undefined || state.guide_data_array.length <= index)
        {
            return false;
        }

        return true;
    }

    function GuideClick(index)
    {
        if(state.guide_data_array === undefined || state.guide_data_array.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType1', View:true, Type:1, No:state.guide_data_array[index].no});
    }

    function GetFAQClick(index)
    {
        if(state.faq_data_array === undefined || state.faq_data_array.length <= index)
        {
            return false;
        }

        return true;
    }

    function FAQClick(index)
    {
        if(state.faq_data_array === undefined || state.faq_data_array.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType1', View:true, Type:3, No:state.faq_data_array[index].no});
    }
    
    function GetQAClick(index)
    {
        if(state.qa_data_array === undefined || state.qa_data_array.length <= index)
        {
            return false;
        }

        return true;
    }

    function QAClick(index)
    {
        if(state.qa_data_array === undefined || state.qa_data_array.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType2', View:true, No:state.qa_data_array[index].no});
    }

    function GetTermsClick(index)
    {
        if(state.terms_data_array === undefined || state.terms_data_array.length <= index)
        {
            return false;
        }

        return true;
    }

    function TermsClick(index)
    {
        if(state.terms_data_array === undefined || state.terms_data_array.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType1', View:true, Type:4, No:state.terms_data_array[index].no});
    }

    function OpenWriteModal()
    {
        dispatch({type:'UpdateWriteModal', View:true});
    }

    if (!isOpen) return null;

    //if(First === true)
    //{
    //    RequestNotice();
    //    setFirst(false);
    //}

    if(state.qa_refresh === true)
    {
        dispatch({type:'UpdateQARefresh', Refresh:false});
        setQAStartIndex(1);
        setQATotalCount(-1);
        RequestQA(1);
    }

    return (
        <div className="service-center-modal-overlay" onClick={Close}>
            <div className='service-center-modal-button-box' onClick={(e) => e.stopPropagation()}>
                <div className="service-center-notice-tab" style={{backgroundColor: TabType === 0 ? "RGB(255,255,255)" : "RGB(172,172,172)"}} onClick={() => ChangeView(0)}><h2>공지사항</h2></div>
{/*                 <div className="service-center-guide-tab" style={{backgroundColor: TabType === 1 ? "RGB(255,255,255)" : "RGB(172,172,172)"}} onClick={() => ChangeView(1)}><h2>가이드</h2></div>  */}
                <div className="service-center-qa-tab" style={{backgroundColor: TabType === 2 ? "RGB(255,255,255)" : "RGB(172,172,172)"}} onClick={() => ChangeView(2)}><h2>1:1문의</h2></div>
                <div className="service-center-faq-tab" style={{backgroundColor: TabType === 3 ? "RGB(255,255,255)" : "RGB(172,172,172)"}} onClick={() => ChangeView(3)}><h2>FAQ</h2></div>
                <div className="service-center-terms-tab" style={{backgroundColor: TabType === 4 ? "RGB(255,255,255)" : "RGB(172,172,172)"}} onClick={() => ChangeView(4)}><h2>약관</h2></div>
                <div className="service-center-guide-tab" style={{backgroundColor: TabType === 1 ? "RGB(255,255,255)" : "RGB(172,172,172)"}} onClick={() => ChangeView(1)}><h2>개인정보처리방침</h2></div>
                <button className="service-center-modal-close" onClick={Close}>
                    <h2>X</h2>
                </button>
            </div>
            <div className="service-center-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className='service-center-notice-box' style={{ display: TabType === 0 ? 'block' : 'none' }}>
                    <div className='service-center-notice-table'>
                        <table>
                        <thead>
                            <tr>
                                <th className='table-number'>넘버</th>
                                <th className='table-title'>제목</th>
                                <th className='table-date'>등록 일시</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td onClick={() => GetNoticeClick(index) === true && NoticeClick(index)} style={{cursor: GetNoticeClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetNoticeNo(index)}</td>
                                    <td onClick={() => GetNoticeClick(index) === true && NoticeClick(index)} style={{cursor: GetNoticeClick(index) === true ? 'pointer' : 'default'}}>{GetNoticeTitle(index)}</td>
                                    <td onClick={() => GetNoticeClick(index) === true && NoticeClick(index)} style={{cursor: GetNoticeClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetNoticeRegisterTime(index)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                </div>
                <div className='service-center-guide-box' style={{ display: TabType === 1 ? 'block' : 'none'   }}>
                  {/*   <div className='service-center-guide-table'>
                    <table>
                        <tr>
                            <th className='table-number'>넘버</th>
                            <th className='table-title'>제목</th>
                            <th className='table-date'>등록 일시</th>
                        </tr>
                        {Array.from({length:10}).map((_, index)=>(
                            <tr>
                                <td onClick={() => GetGuideClick(index) === true && GuideClick(index)} style={{cursor: GetGuideClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetGuideNo(index)}</td>
                                <td onClick={() => GetGuideClick(index) === true && GuideClick(index)} style={{cursor: GetGuideClick(index) === true ? 'pointer' : 'default'}}>{GetGuideTitle(index)}</td>
                                <td onClick={() => GetGuideClick(index) === true && GuideClick(index)} style={{cursor: GetGuideClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetGuideRegisterTime(index)}</td>
                            </tr>
                        ))}
                        </table>
                    </div> */}

                <div className='service-center-terms-view'>

                <h1>개인정보처리방침</h1><br></br>
시행일자 : 2025.02.14<br></br>
총칙<br></br>
㈜스포토(이하 '회사'라 함) 회원의 개인정보를 적극적으로 보호하며, 『정보통신망이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”』), 『개인정보보호법』 등<br></br>
정보통신서비스 제공자가 준수하여야 하는 관련 법령을 준수함으로써 회원 권익 보호에 최선을 다하고 있습니다.<br></br>
회사는 본 개인정보처리방침을 통해 회원이 제공하는 개인정보를 어떠한 목적과 방식으로 이용하고 있는지, 회원의 개인정보를 보호하기 위해 회사가 어떠한 노력을 기울이고 있는지 알려드립니다.<br></br><br></br>

(제 1조) 개인정보의 수집 항목과 이용목적 및 방법<br></br>
회사는 서비스 제공을 위하여 필요한 정보를 아래와 같은 목적으로 필수/선택 정보로 구분하여, 회원의 동의 하에 수집하고 있습니다.<br></br>
아래의 목적으로 수집되는 정보들은 필수 수집 안내 및 선택 동의하거나, 서비스 이용 과정에서 회원이 직접 입력, 개별 동의함으로써 수집됩니다.<br></br>
구분	수집 및 이용목적	필수/선택	수집항목<br></br>
회원 가입	회원 가입	필수	[멤버십] 아이디, 비밀번호, 휴대폰번호, 이메일 주소<br></br>
맞춤형 광고	선택	광고식별자, 서비스 이용기록, 쿠키(Cookie)<br></br>
고객 상담	이용자 식별 및 연락	필수	이메일 주소, 연락처(휴대폰 번호, 일반전화번호)<br></br>
상담내용 확인	필수	ID, 이름, 닉네임, 기타 상담에 필요한 정보<br></br>
결제/환불	결제	필수	신용카드 : 신용카드: 카드사명, 카드번호, 유효기간, cvc<br></br>
(결제 방식에 따라 수집 정보가 상이할 수 있습니다)<br></br>
휴대전화 : 휴대폰번호, 통신사명<br></br>
계좌이체 : 은행명, 계좌번호, 현금영수증정보<br></br>
가상계좌 : 은행명, 입금자명, 현금영수증정보<br></br><br></br>

*실제 유료 결제에 필요한 정보는 google사에서 수집하고 있습니다.<br></br>
취소 또는 환불	필수	은행명, 계좌번호, 예금주<br></br>
*본인 여부 확인을 위해 신분증, 가족관계증명서, 휴대폰가입증명서, 등/초본, 통장사본, 충전 방식 별 완납 영수증 및 완납 서류가 수집될 수 있습니다.<br></br>
(충전방식에 따라 취소에 필요한 수집내용이 달라질 수 있습니다)<br></br>
서비스 이용	부정행위 탐지를 위한 기타정보 자동수집	필수	<br></br>
기기정보, 이동통신사정보, IP, 접속기록, 서비스 이용기록, 불량이용기록, 다운로드 기록, 대금결제 기록, 쿠키(Cookie)<br></br><br></br>

서비스 이용과정에서 정보를 자동화된 방법으로 생성하여 저장하거나, 고유한 정보를 원래의 값을 확인하지 못하도록 안전하게 변환하여 수집합니다. 연계 여부에 따라 개인 정보에 해당할 수도, 해당하지 않을 수도 있습니다.<br></br><br></br>

(제 2조) 개인정보의 보유 및 이용기간<br></br>
㈜스포토는 (이하 ‘회사’) “정보통신망 이용촉진 및 정보보호 등에 관한 법률” 및 “개인정보보호법”에 따라 이용자의 개인정보를 제3자에게 제공해야 하는 경우 동의를 받고 있으며, 동의한 경우 이외에는 개인정보를 제3자에게 제공하지 않습니다.<br></br>
회사는 회원의 개인정보를 고지 및 동의 받은 기간 동안 보유하고 이용하며, 개인정보의 수집 및 이용목적이 달성되거나 보유기간 만료, 이용자의 수집 및 이용 동의 철회 시 지체없이 파기하는 것을 원칙으로 합니다.<br></br>
최종 로그인 후 계속해서 365일 동안 이용 기록이 없는 장기 미 접속자에 대해서는 관계 법령에 따라 개인정보 보호를 위해 계약을 해지하고 개인정보 파기 등 필요한 조치를 취할 수 있습니다.<br></br>
이 경우, 조치일 30일 전까지 필요한 조치가 취해진다는 사실과 개인정보 보유기간 만료일 및 개인정보의 항목을 “회원”에게 사전에 등록한 전자메일을 통해 고지합니다.<br></br>
게임 서비스를 지속적으로 이용하고자 하는 경우, 최종 로그인 일시로부터 365일이 경과하기 전까지 로그인 하시기 바랍니다.<br></br>
회사는 개인정보 도용 등으로 인한 피해 발생시 복구와 피해자 보호 등을 위해 회원의 성명, 연락처 등 회원가입 시 수집한 개인정보를 해지한 날로부터 최대 14일 동안 임시 보관할 수 있으며,<br></br>
ID는 타 서비스와의 연계로 인해 30일간 보유하고 이후에는 재생할 수 없는 방법으로 완전히 삭제 됩니다.<br></br>
다음의 정보에 대해서는 “보존 근거” 및 법령에서 명시한 기간 동안 보존합니다.<br></br>
① 이벤트 및 서비스 마케팅을 위해 수집한 정보<br></br>
- 수집 목적 달성 후 3개월 보관 (이벤트 마다 보관 일수가 다를 수 있으며, 개별 이벤트에 적용된 기간을 우선 적용)<br></br>
② 관련 법령에 따라 일정기간 보존해야 하는 경우<br></br>
관련 법령	수집 정보	보유 기간<br></br>
정보통신망 이용촉진 및 정보보호 등에 관한 법률	로그인 정보	1년<br></br>
통신비밀보호법	서비스 이용 관련 정보	3개월<br></br>
전자상거래 등에서의 소비자 보호에 관한 법률	소비자의 불만 또는 분쟁처리에 관한 기록	3년<br></br>
표시/광고에 관한 기록	6개월<br></br>
계약 또는 청약철회 등에 관한 기록	5년<br></br>
대금결제 및 재화 등의 공급에 관한 기록	5년<br></br>
국세기본법	세법이 규정하는 모든 거래에 관한 장부 및 증빙서류	5년<br></br><br></br>

(제 3조) 개인정보의 파기절차 및 방법<br></br>
이용자의 개인정보는 수집 및 이용목적이 달성되면 지체 없이 파기되며, 파기 절차 및 방법은 다음과 같습니다.<br></br>
파기절차	이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 보관 기간 동안 보관된 후 파기<br></br>
파기방법	출력물 형태 : 분쇄기로 분쇄하거나 소각을 통하여 파기<br></br>
전자적 파일 형태 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제<br></br><br></br>

(제 4조) 고유식별정보의 처리<br></br>
고유식별정보란 『개인정보보호법』 및 동 시행령에서 “대통령령으로 정하는 정보”로 주민등록번호, 여권번호, 운전면허번호, 외국인등록번호를 말합니다.<br></br>
회사는 아래와 같은 목적으로 고유식별정보를 수집하여 처리하고 있습니다.<br></br>
- 현물 경품 당첨자의 제세공과금 처리<br></br><br></br>

(제 5조) 개인정보의 제공 및 공유<br></br>
회사는 새로운 기술 개발과 보다 나은 서비스 제공을 위하여 회원의 개인정보를 공유할 수 있습니다.<br></br>
이 경우에도 정보 수집 또는 정보 제공 이전에 회원에게 개인정보를 공유할 기관이나 단체, 비즈니스 파트너가 누구인지, 어떤 정보가 왜 필요한지,<br></br>
그리고 언제까지 어떻게 보호되고 관리되는지 알려드리고 동의를 구하는 절차를 거치게 됩니다.<br></br>
회원의 동의가 없는 경우에는 추가적인 정보를 임의로 수집하거나 공유하지 않습니다.<br></br>
성별, 연령별 기타 특정 조건의 집단에 대한 광고 게재 및 발송 시에도 회원의 개인정보는 광고를 의뢰한 개인이나 기업 등에 제공되지 않으며,<br></br>
기타 통계처리나 학술연구, 시장조사 등 공공의 목적달성을 위하여 제공이 필요한 경우에도 특정한 개인을 식별할 수 없는 형태로만 제공됩니다.<br></br>
회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우 예외로 합니다.<br></br>
① 이용자가 사전에 공개 또는 제공에 동의한 경우<br></br>
② 전기통신기본법, 전기통신사업법 등에 관계 법령에 의하여 자료 제공이 강제되는 경우이거나, 적법한 절차에 의한 법원, 수사기관, 기타 행정기관의 요청이 있는 경우<br></br>
③ 홈페이지에 게시한 서비스 이용약관이나 운영정책 등 회사가 정한 정책을 위반한 경우<br></br>
④ 서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적인 조치를 취하기 위해 개인 정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우<br></br>
⑤ 결제중재센터(http://www.spotobet.com)<br></br><br></br>

(제 6조) 이용자의 권리와 그 행사방법<br></br>
회원은 언제든지 개인정보의 제공 동의를 철회할 수 있습니다. 개인정보의 제공 동의 철회를 위해서는 서비스 내 “회원 탈퇴” 또는 “계정 삭제”를 클릭하여 탈퇴가 가능합니다.<br></br>
또한, 등록되어 있는 자신의 개인정보를 조회하거나 수정하는 등의 법률에서 정한 권리를 행사할 수 있습니다. 이용자 및 법정대리인의 권리는 '회원정보' 페이지에서 직접 처리하거나 '문의하기'를 통해 요청할 수 있습니다. <br></br>
회원 탈퇴로 인하여 개인정보가 파기되는 경우, 해당 이용자가 회사의 서비스를 이용하면서 생성, 축적된 관련정보가 함께 파기될 수 있습니다.<br></br>
이용자 ID는 어떠한 경우에도 변경이 불가능하며, 부득이한 사유로 변경하고자 한다면 해당 ID를 해지한 후 재가입해야 합니다.<br></br>
이용자 ID, 비밀번호를 잊어버린 경우, 홈페이지의 "아이디 찾기 / 비밀번호 찾기 메뉴"를 이용하시기 바랍니다.<br></br>
회원이 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.<br></br>
또한 잘못된 개인정보를 제 3자에게 이미 제공한 경우, 정정 처리결과를 제 3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.<br></br>
회사는 회원의 개인정보 전부 또는 일부에 대하여 열람 및 정정 요구를 거절할 정당한 사유가 있다면 회원에게 이를 지체 없이 통지하고 그 이유를 설명합니다.<br></br><br></br>

(제 7조) 서비스 이용 기록 분석<br></br>
회사는 회원에게 적합하고 보다 유용한 서비스를 제공하기 위해서 회원의 광고 식별자와 분석 소프트웨어를 사용하고 있습니다.<br></br>
광고 식별자는 Android 광고 ID, Apple의 광고용 ID 등과 같이, 미영구적이고 비개인적인 식별자로 기기의 설정을 변경함으로써,<br></br>
광고 식별자가 관심 사항에 기반하는 광고를 위해서 사용되지 못하도록 거부하거나 재설정할 수 있으며, 개인정보와 연결되거나 개인을 식별하는데 사용되지 않습니다.<br></br>
분석 소프트웨어는 회원이 웹 사이트를 방문하거나 모바일 서비스를 이용할 때 자동으로 생성되는 정보를 분석하기 위해 사용되며, 회원은 이를 거부할 수 있습니다.<br></br>
① 광고 식별자 수집 거부<br></br>
- Android인 경우 [설정 - Google -광고] 또는 [설정 - 일반 - 계정 및 동기화 - Goolge - 개인정보 및 개인정보보호 - 광고설정]<br></br>
- IOS인 경우 [설정 - 개인정보 - 광고]<br></br><br></br>

(제 8조) 개인정보의 기술적 / 관리적 / 물리적 보호대책<br></br>
회사는 회원의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위해 기술적, 관리적 대책을 마련하고 이를 이행하고 있습니다.<br></br>
다만, 회사가 개인정보보호 의무를 다 하였음에도 불구하고 기기 분실 등 회원 본인의 부주의로 중요 개인정보가 유출해 발생한 문제에 대해 회사는 일절 책임을 지지 않습니다.<br></br>
기술적 대책<br></br>
① 회사는 관련 법령에서 지정한 항목을 암호화하여 보관하고 있으며, 개인정보의 확인 및 변경은 본인의 요청을 통해서만 가능합니다.<br></br>
② 회사는 암호화 통신을 통하여 네트워크 상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.<br></br>
③ 회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안 프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.<br></br>
④ 회사는 만약의 사태를 대비하여 개인정보를 주기적으로 백업하고 있으며, 백신 프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 예방하기 위한 조치를 취하고 있습니다.<br></br>
⑤ 회사는 개인정보를 처리하는 개인정보처리시스템에 주기적인 접근 권한의 검토와 침입차단 시스템을 이용하여 내/외부로부터의 무단 접근을 통제하고 있습니다.<br></br>
관리적 대책<br></br>
① 회사는 회원의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있으며, 그 최소 인원에 해당하는 자는 다음과 같습니다.<br></br>
- 회원을 직접 상대로 하여 마케팅, 이벤트, 고객지원, 배송 업무를 수행하는 자<br></br>
- 개인정보보호 책임자를 포함한 개인정보보호업무를 담당하는 자<br></br>
- 기타 업무상 개인정보 처리가 불가피한 자<br></br>
② 회사는 개인정보취급자와 수탁사를 대상으로 개인정보보호 의무 등에 관하여 정기적으로 점검하고, 교육하고 있습니다.<br></br>
③ 회사는 개인정보보호 업무를 전담하는 부서에서 개인정보처리지침을 수립하여 관리하고 있습니다.<br></br>
또한 내부 규정 준수여부를 정기적으로 확인하여 문제가 발견될 경우, 즉시 바로잡을 수 있도록 노력하고 있습니다.<br></br>
물리적 대책<br></br>
① 비인가자에 대한 출입 통제<br></br>
개인정보를 보관하고 있는 개인정보시스템의 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.<br></br>
② 문서 보안을 위한 잠금 장치 사용<br></br>
개인정보가 포함된 서류, 보조저장매체 등을 잠금 장치가 있는 안전한 장소에 보관하고 있습니다.<br></br>
(제 9조) 개인정보 처리 방침의 변경에 관한 사항<br></br><br></br>

개인정보처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있으며, 회사가 개인정보처리방침을 개정하는 경우 그 변경사항을 이용자가 쉽게 알아볼 수 있도록 홈페이지를 통해 고지하고 있습니다. 개인정보 처리방침 변경은 게임 서비스내 '공지사항' 이력에서 변경전, 후를 비교하여 확인할 수 있습니다.<br></br>
개인정보처리방침을 사이트 화면에 공개함으로써 회원이 언제나 용이하게 확인할 수 있도록 하고 있으니 사이트 방문 시 수시로 내용을 확인하시기 바랍니다.  <br></br><br></br>

(제 10조) 개인정보 보호책임자 및 담당부서<br></br>
회사는 회원의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 아래와 같이 개인정보 보호책임자 및 담당부서를 지정하고 있습니다.<br></br>
개인정보 보호책임자	개인정보 보호 담당부서<br></br>
이 름 : 김성권<br></br>
이메일 : spotobet@gmail.com	부서명 : 보안팀<br></br><br></br>

기타 개인정보침해에 대한 신고나 상담이 필요한 경우, 아래 기관에 문의하시기 바랍니다.<br></br>
- 개인정보침해신고센터 (http://privacy.kisa.or.kr/ 국번없이 118)<br></br>
- 대검찰청 사이버범죄수사단 (http://www.spo.go.kr/ 02-3480-3571)<br></br>
- 경찰청 사이버테러대응센터 (http://www.ctrc.go.kr/ 국번없이 182)<br></br><br></br>

(제 11조) 고지의 의무<br></br>
개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 7일전부터 “공지사항”을 통해 공지하는 것을 원칙으로 하며,<br></br>
변경사항으로 인하여 회원에게 불이익이 발생할 수 있는 사항의 변경에 대해서는 개정 30일 이전부터 고지하도록 하겠습니다.<br></br><br></br>

(부칙)<br></br>
본 방침은 2025년 2월 14일부터 적용됩니다.



                </div>

                </div>
                <div className='service-center-qa-box' style={{ display: TabType === 2 ? 'block' : 'none' }}>
                <div className='service-center-qa-wirte-button' onClick={OpenWriteModal}><h2>글쓰기</h2></div>
                    <div className='service-center-qa-table'>
                    <table>
                        <thead>
                            <tr>
                                <th className='table-number'>넘버</th>
                                <th className='table-title'>제목</th>
                                <th className='table-date'>등록 일시</th>
                                <th className='table-status'>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetQANo(index)}</td>
                                    <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default'}}>{GetQATitle(index)}</td>
                                    <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetQARegisterTime(index)}</td>
                                    <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetQAStatus(index)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className='service-center-qa-count-box'>
                        {Array.from({length:10}).map((_, index)=>(
                            <div className='service-center-qa-count' onClick={() => QAStartIndexClick(index + 1)} style={{cursor: GetQAStartIndexCursor(index + 1) === true ? 'pointer' : 'auto'}}><h2 style={{fontWeight: QAStartIndex === index + 1 ? "bold" : "100"}}>{index+1}</h2></div>   
                        ))}
                    </div>
                </div>
                <div className='service-center-faq-box' style={{ display: TabType === 3 ? 'block' : 'none'   }}>
                    <div className='service-center-faq-table'>
                    <table>
                        <thead>
                            <tr>
                                <th className='table-number'>넘버</th>
                                <th className='table-title'>제목</th>
                                <th className='table-date'>등록 일시</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td onClick={() => GetFAQClick(index) === true && FAQClick(index)} style={{cursor: GetFAQClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetFAQNo(index)}</td>
                                    <td onClick={() => GetFAQClick(index) === true && FAQClick(index)} style={{cursor: GetFAQClick(index) === true ? 'pointer' : 'default'}}>{GetFAQTitle(index)}</td>
                                    <td onClick={() => GetFAQClick(index) === true && FAQClick(index)} style={{cursor: GetFAQClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetFAQRegisterTime(index)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className='service-center-faq-count-box'>
                        {Array.from({length:10}).map((_, index)=>(
                            <div className='service-center-faq-count' onClick={() => FAQStartIndexClick(index + 1)} style={{cursor: GetFAQStartIndexCursor(index + 1) === true ? 'pointer' : 'auto'}}><h2 style={{fontWeight: FAQStartIndex === index + 1 ? "bold" : "100"}}>{index+1}</h2></div>   
                        ))}
                    </div>
                </div>
                <div className='service-center-terms-box' style={{ display: TabType === 4 ? 'block' : 'none'   }}>
                   {/*  <div className='service-center-terms-table'>
                    <table>
                        <tr>
                            <th className='table-number'>넘버</th>
                            <th className='table-title'>제목</th>
                            <th className='table-date'>등록 일시</th>
                        </tr>
                        {Array.from({length:10}).map((_, index)=>(
                            <tr>
                                <td onClick={() => GetTermsClick(index) === true && TermsClick(index)} style={{cursor: GetTermsClick(index) === true ? 'pointer' : 'default',textAlign:"center"}}>{GetTermsNo(index)}</td>
                                <td onClick={() => GetTermsClick(index) === true && TermsClick(index)} style={{cursor: GetTermsClick(index) === true ? 'pointer' : 'default'}}>{GetTermsTitle(index)}</td>
                                <td onClick={() => GetTermsClick(index) === true && TermsClick(index)} style={{cursor: GetTermsClick(index) === true ? 'pointer' : 'default', textAlign:"center"}}>{GetTermsRegisterTime(index)}</td>
                            </tr>
                        ))}
                        </table>
                    </div> */}
                    <div className='service-center-terms-view'>
                       <h1> 모바일 이용약관 </h1>
(제1조) 목적<br></br>
이 약관은 ㈜스포토(이하 “회사”라 합니다)가 모바일 기기를 통해 제공하는 애플리케이션 서비스 및 이에 부수하는 네트워크,웹사이트 기타서비스(이하 ”서비스”라 합니다.)의 이용에 대한 회사와 서비스 이용자의 권리•의무 및 책임사항,기타 필요한 사항을 규정함을 목적으로 합니다.<br></br><br></br>

(제2조) 용어의 정의<br></br>
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br></br><br></br>

“회사”라 함은 모바일 기기를 통하여 서비스를 제공하는 사업자를 의미합니다.<br></br>
“회원”이란 이 약관에 따라 이용계약을 체결하고,회사가 제공하는 서비스를 이용하는 자를 의미합니다.<br></br>
“임시회원”이란 일부 정보만 제공하고 회사가 제공하는 서비스의 일부만 이용하는 자를 의미합니다.<br></br>
“모바일 기기”란 콘텐츠를 다운로드 받거나 설치하여 사용할 수 있는 기기로써,휴대폰,스마트폰, 휴대정보단말기(PDA), 태블릿 등을 의미합니다.<br></br>
“계정정보”란 회원의 회원번호와 외부계정정보,기기정보,닉네임,프로필 사진,친구목록 등 회원이 회사에 제공한 정보와 애플리케이션이용정보(캐릭터 정보,아이템,재화 등), 이용요금 결제 정보 등을 통칭합니다.<br></br>
“콘텐츠”란 모바일 기기로 이용할 수 있도록 회사가 서비스 제공과 관련하여 디지털방식으로 제작한 유료 또는 무료의 내용물 일체( 애플리케이션 및 네트워크 서비스 등)를 의미합니다.<br></br>
“오픈마켓”이란 모바일 기기에서 애플리케이션 콘텐츠를 설치하고 결제할 수 있도록 구축된 전자상거래 환경을 의미합니다.<br></br>
“유료 결제”란 서비스 내 콘텐츠 등을 구매 또는 이용하기 위해 회사가 인정하는 결제 업체를 통한 결제 행위를 의미합니다.<br></br>
“애플리케이션”이란 회사가 제공하는 서비스를 이용하기 위하여, 모바일 기기를 통해 다운로드 받거나 설치하여 사용하는 프로그램 일체를 의미합니다.<br></br>
“애플리케이션서비스”라 함은 회사가 제공하는 서비스의 하나로서 회원이 모바일 기기에서 실행하는 애플리케이션 및 이에 부수하는 서비스를 의미합니다.<br></br>
* 이 약관에서 사용하는 용어의 정의는 제 2조 용어의 정의를 정하는 것을 제외하고는 관계 법령 및 서비스별 정책에서 정하는 바에 의하여,이에 정하지 아니한 것은 일반적인 상 관례를 따릅니다.<br></br><br></br>

(제3조) 회사정보 등의 제공<br></br>
회사는 다음 각 호의 사항을 회원이 알아보기 쉽도록 애플리케이션 서비스 내에 표시합니다. 다만, 개인정보처리방침과 약관은 회원이 연결화면을 통하여 볼 수 있도록 할 수 있습니다.<br></br><br></br>

상호 및 대표자의 성명<br></br>
영업소 소재지 주소( 회원의 불만을 처리할 수 있는 곳의 주소를 포함한다)<br></br>
전화번호,전자우편주소<br></br>
사업자 등록번호<br></br>
통신판매업 신고번호<br></br>
개인정보처리방침<br></br>
서비스 이용약관<br></br><br></br>

(제4조) 약관의 효력 및 변경<br></br>
회사는 이 약관의 내용을 회원이 알 수 있도록 애플리케이션 서비스 내 또는 그 연결화면에 게시합니다.<br></br>
이 경우 이 약관의 내용 중 서비스 중단,청약철회,환급,계약 해제&해지,회사의 면책사항 등과 같은 중요한 내용은 굵은 글씨,색채,부호 등으로 명확하게 표시하거나 별도의 연결화면 등을 통하여 회원이 알아보기 쉽게 처리합니다.<br></br>
회사가 약관을 개정할 경우에는 적용일자 및 개정내용,개정사유 등을 명시하여 최소한 그 적용일 7일 이전부터 애플리케이션 서비스내 또는 그 연결화면에 게시하여 회원에게 공지합니다.<br></br>
다만,변경된 내용이 회원에게 불리하거나 중대한 사항의 변경인 경우에는 그 적용일 30일 이전까지 본문과 같은 방법으로 공지하고 제 29조 제 1항의 방법으로 회원에게 통지합니다.이 경우 개정 전 내용과 개정 후 내용을 명확하게 비교하여 회원이 알기 쉽도록 표시합니다.<br></br>
회사가 약관을 개정할 경우 개정약관 공지 후 개정약관의 적용에 대한 회원의 동의 여부를 확인합니다.<br></br>
회사는 제 2항의 공지 또는 통지를 할 경우 회원이 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않으면 동의한 것으로 볼 수 있다는 내용도 함께 공지 또는 통지를 하며,<br></br>
회원이 이 약관 시행일까지 거부의 의사표시를 하지 않는 다면 개정약관에 동의한 것으로 볼 수 있습니다.회원이 개정약관에 대해 동의하지 않는 경우 회사 또는 회원은 서비스 이용계약을 해지할 수 있습니다.<br></br>
회사는 회원이 회사와 이 약관의 내용에 관하여 질의 및 응답을 할 수 있도록 조치를 취합니다.<br></br>
회사는 『전자상거래 등에서의 소비자 보호에 관한 법률』,『약관의 규제에 관한 법률』,『애플리케이션산업진흥에 관한 법률』,<br></br>
『정보통신망 이용촉진 및 정보보호 등에 관한 법률』,『콘텐츠산업진흥법』 등에 관련 법령에 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br></br><br></br>

(제5조) 이용계약의 체결 및 적용<br></br>
이용계약은 회원이 되고자 하는 자(이하 “가입신청자”라 합니다)가 이 약관의 내용에 대하여 동의를 한 다음 서비스 이용 신청을 하고, 회사가 그 신청에 대해서 승낙함으로써 체결됩니다.<br></br>
회사는 가입신청자의 신청에 대하여 승낙함을 원칙으로 합니다. 다만, 회사는 다음 각 호의 어느 하나에 해당하는 이용 신청에 대해서는 승낙을 거절할 수 있습니다.<br></br>
① 이용신청서 내용을 허위로 기재하거나 이용신청 요건을 충족하지 못한 경우<br></br>
② 회사가 서비스를 제공하지 않는 국가에서 비정상적이거나 우회적인 방법을 통해 서비스를 이용하는 경우<br></br>
③ 『애플리케이션산업진흥에 관한 법률』 등 관련 법령에서 금지하는 행위를 할 목적으로 신청하는 경우<br></br>
④ 사회의 안녕과 질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br></br>
⑤ 부정한 용도로 애플리케이션 서비스를 이용하고자 하는 경우<br></br>
⑥ 영리를 추구할 목적으로 애플리케이션 서비스를 이용하고자 하는 경우<br></br>
⑦ 그 밖에 각 호에 준하는 사유로서 승낙이 부적절하다고 판단되는 경우<br></br>
회사는 다음 각 호의 어느 하나에 해당하는 경우 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.<br></br>
① 회사의 설비에 여유가 없거나, 특정 모바일 기기의 지원이 어렵거나, 기술적 장애가 있는 경우<br></br>
② 서비스 상의 장애 또는 서비스 이용요금, 결제수단의 장애가 발생한 경우<br></br>
③ 그 밖의 각 호에 준하는 사유로서 이용신청의 승낙이 어렵다고 판단되는 경우<br></br><br></br>

(제6조) 약관 외 준칙<br></br>
이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 『전자상거래 등에서의 소비자보호에 관한 법률』,『약관의 규제에 관한 법률』,『애플리케이션산업진흥에 관한 법률』,<br></br>
『정보통신망이용촉진 및 정보보호 등에 관한 법률』,『콘텐츠산업진흥법』 등 관련 법령 또는 상 관례에 따릅니다.<br></br><br></br>

(제7조) 운영정책<br></br>
약관을 적용하기 위하여 필요한 사항과 약관에서 구체적 범위를 정하여 위임한 사항을 애플리케이션 서비스 운영정책(이하 ”운영정책”이라 합니다)으로 정할 수 있습니다.<br></br>
회사는 운영정책의 내용을 회원이 알 수 있도록 애플리케이션 서비스 내 또는 그 연결화면에 게시합니다.<br></br>
운영정책을 개정하는 경우에는 제 4조 2항의 절차에 따릅니다. 다만,운영정책이 개정내용이 다음 각 호의 어느 하나에 해당하는 경우에는 제 2항의 방법으로 사전에 공지합니다.<br></br>
① 약관에서 구체적으로 범위를 정하여 위임한 사항을 개정한 경우<br></br>
② 회원의 권리•의무와 관련 없는 사항을 개정하는 경우<br></br>
③ 운영정책의 내용이 약관에서 정한 내용과 근본적으로 다르지 않고 회원이 예측할 수 있는 범위 내에서 운영정책을 개정하는 경우<br></br><br></br>

(제8조) 개인정보의 보호 및 사용<br></br>
회사는 관련 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력하며,개인정보의 보고 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침에 따릅니다.<br></br>
다만, 회사가 제공하는 서비스 이외의 링크된 서비스에서는 회사의 개인정보처리방침이 적용되지 않습니다.<br></br>
서비스의 특성에 따라 회원의 개인정보와 관련이 없는 닉네임,캐릭터,사진,상태정보 등 자신을 소개하는 내용이 공개될 수 있습니다.<br></br>
회사는 관련 법령에 의해 관련 국가기관 등의 요청이 있는 경우를 제외하고는 회원의 개인정보를 본인의 동의 없이 타인에게 제공하지 않습니다.<br></br>
회사는 회원의 귀책사유로 개인정보가 유출되어 발생한 피해에 대하여 책임을 지지 않습니다.<br></br><br></br>

(제9조) 회사의 의무<br></br>
회사는 관련 법령,이 약관에서 정하는 권리의 행사 및 의무의 이행을 신의에 따라 성실하게 준수합니다.<br></br>
회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안 시스템을 갖추어야 하며, 개인정보처리방침을 공시하고 준수합니다.<br></br>
회사는 이 약관 및 개인정보처리방침에서 정한 경우를 제외하고는,회원의 개인정보가 제 3자에게 공개 또는 제공되지 않도록 합니다.<br></br>
회사는 계속적이고 안정적인 서비스의 제공을 위하여 서비스 개선을 하던 중 설비에 장애가 생기거나<br></br>
데이터 등이 멸실•훼손된 때에는 천재지변,비상사태,현재의 기술로는 해결이 불가능한 장애나 결함 등 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구 하도록 최선의 노력을 다합니다.<br></br><br></br>

(제10조) 회원의 의무<br></br>
회원은 회사에서 제공하는 서비스의 이용과 관련하여 다음 각 호에 해당하는 행위를 해서는 안됩니다.<br></br>
① 이용신청 또는 회원 정보 변경 시 허위사실을 기재하는 행위<br></br><br></br>
② 회사가 제공하지 않는 서비스나 비정상적인 방법을 통해 사이버 자산(ID ,캐릭터 , 아이템,애플리케이션 머니 등)을 매매 또는 증여하거나,이를 취득하여 이용하는 행위<br></br>
③ 회사의 직원이나 운영자를 가장하거나 타인의 명의를 도용하여 글을 게시하거나 메일을 발송하는 행위,타인으로 가장하거나 타인과의 관계를 허위로 명시하는 행위<br></br>
④ 타인의 신용카드,유/무선 전화,은행 계좌 등을 도용하여 유료 콘텐츠를 구매하는 행위,다른 회원의 ID 및 비밀번호를 부정사용 하는 행위<br></br>
⑤ 다른 회원의 개인정보를 무단으로 수집,저장,게시 또는 유포하는 행위<br></br>
⑥ 도박 등 사행행위를 하거나 유도하는 행위,음란,저속한 정보를 교류,게재하거나 음란사이트를 연결(링크)하는 행위,수치심,혐오감 또는 공포심을 일으키는 말,소리,글,그림,사진 또는 영상을 타인에게 전송 또는 유포하는 행위 등 서비스를 불건전하게 이용하는 행위<br></br>
⑦ 서비스를 무단으로 영리,영업,광고,홍보,정치활동,선거운동 등 본래의 용도 이외의 용도로 이용하는 행위<br></br>
⑧ 회사의 서비스를 이용하여 얻은 정보를 무단으로 복제,유통,조장하거나 상업적으로 이용하는 행위,알려지거나 알려지지않은 버그를 악용하여 서비스를 이용하는 행위<br></br>
⑨ 타인을 기망하여 이득을 취하는 행위,회사의 서비스의 이용과 관련하여 타인에게 피해를 입히는 행위<br></br>
⑩ 회사나 타인의 지적재산권 또는 초상권을 침해하는 행위,타인의 명예를 훼손하거나 손해를 가하는 행위<br></br>
⑪ 법령에 의하여 전송 또는 게시가 금지된 정보 (컴퓨터 프로그램)나 컴퓨터 소프트웨어,하드웨어또는 전기통신장비의 정상적인 작동을 방해,파괴할 목적으로 고안된 바이러스,컴퓨터코드,파일,프로그램 등을 고의로 전송,게시,유포 또는 사용하는 행위<br></br>
⑫ 회사로부터 특별한 권리를 부여 받지 않고 애플리케이션을 변경하거나,애플리케이션에 다른 프로그램을 추가/삽입하거나 서버를 해킹,역설계하거나 소스 코드나 애플리케이션 데이터를 유출,변경하거나 별도의 서버를 구축하건,웹사이트의 일부분을 임의로 변경,도용하여 회사를 사칭하는 행위<br></br>
⑬ 그 밖에 관련 법령에 위반되거나 선량한 풍속 기타 사회통념에 반하는 행위<br></br>
회원의 계정 및 모바일 기기에 관한 관리 책임은 회원에게 있으며,이를 타인이 이용하도록 하게 하여서는 안 됩니다.<br></br>
모바일 기기의 관리 부실이나 타인에게 이용을 승낙함으로 인해 발생하는손해에 대해서는 회사는 책임을 지지 않습니다.<br></br>
회원은 각 오픈마켓에서 부정한 결제가 이루어지지 아니하도록 결제 비밀번호 기능을 설정 및 보안 수단을 설정하여 관리해야 합니다.<br></br>
회원의 부주의로 인하여 발생하는 손해에 대해 회사는 책임지지 않습니다.<br></br>

(제11조) 서비스의 제공<br></br><br></br>
회사는 제 5조의 규정에 따라 이용계약이 완료된 회원에게 그 즉시 서비스를 이용할 수 있도록 합니다. 다만, 일부 서비스의 경우 회사의 필요에 따라 지정된 일자부터 서비스를 개시할 수 있습니다.<br></br>
회사는 회원에게 애플리케이션 서비스를 제공할 때 이 약관에 정하고 있는 서비스를 포함하여 기타 부가적인 서비스를 함께 제공할 수 있습니다.<br></br>
회사는 회원의 등급을 구분하고 이용시간,이용횟수,제공 서비스의 범위 등을 세분화하여 이용에 차등을 둘 수 있습니다.<br></br><br></br>

(제12조) 서비스의 이용<br></br>
애플리케이션 서비스는 회사의 영업방침에 따라 정해진 시간 동안 제공합니다.회사는 애플리케이션 서비스 제공시간을 애플리케이션 초기화면이나 애플리케이션 서비스 공지사항에 적절한 방법으로 안내합니다.<br></br><br></br>
제 1항에도 불구하고 회사는 다음 각 호의 경우에는 서비스의 전부 또는 일부를 일시 정지할 수 있습니다.<br></br>
이 경우 회사는 사전에 그 정지의 사유와 기간을 애플리케이션 초기화면이나 애플리케이션 서비스 공지사항 등에 공지합니다.<br></br>
다만,사전에 공지할 수 없는 부득이한 사정이 있는 경우 사후에 공지할 수 있습니다.<br></br>
① 시스템 정기점검,서버의 증설 및 교체,네트워크의 불안정 등의 시스템 운영상 필요한 경우<br></br>
② 정전,서비스 설비의 장애,서비스 이용폭주,기간통신사업자의 설비 보수 또는 점검 등으로 인하여 정상적인 서비스 제공이 불가능한 경우<br></br>
③ 전시,사변,천재지변 또는 이에 준하는 국가비상사태 등 회사가 통제할 수 없는 상황이 발생한 경우<br></br>
회사는 모바일 기기를 위한 전용 애플리케이션 또는 네트워크를 이용하여 서비스를 제공합니다.<br></br>
회원은 애플리케이션을 다운로드하여 설치하거나 네트워크를 이용하여 무료 또는 유료로 서비스를 이용할 수 있습니다.<br></br>
유료 콘텐츠의 경우에는 해당 서비스에 명시된 요금을 지급하여야 이용할 수 있습니다.<br></br>
네트워크를 통해 애플리케이션을 다운로드하거나 서비스를 이용하는 경우에는 가입한 이동통신사에서 정한 별도의 요금이발생할 수 있습니다.<br></br>
다운로드하여 설치한 애플리케이션 또는 네트워크를 통해 이용하는 서비스의 경우에는 모바일 기기 또는 이동통신사의특성에 맞도록 제공됩니다.<br></br>
모바일 기기의 변경•번호변경으로 인해 해외 로밍의 경우 콘텐츠의 전부 또는 일부의 이용이 불가능할 수 있으며,이 경우 회사는 책임을 지지 않습니다.<br></br>
다운로드하여 설치한 애플리케이션 또는 네트워크를 통해 이용하는서비스의 경우 그라운드 작업이 진행될 수 있습니다.<br></br>
이 경우 모바일 기기 또는 이동통신사의 특성에 맞도록 추가요금이 발생할 수 있으며, 이와 관련하여 회사는 책임을 지지 않습니다.<br></br><br></br>

(제13조) 제휴 서비스<br></br>
제휴 서비스는 제휴 서비스는 단 모바일 플랫폼(구글 등)을 이용하는 다른 회원과 함께 이용할 수 있는 서비스입니다.<br></br>
서비스 이용 전 회원은 모바일 플랫폼의 개인 프로필을 포함하여 서비스 제공에 필요한 개인정보의 제공 및 이용에 동의하여야 합니다.이에 동의하지 않으실 경우 서비스 이용에 제한이 있을 수 있습니다.<br></br>
회사는 제휴 서비스를 통해 다수의 서비스를 제공할 수 있습니다.여러 개의 서비스에 가입한 회원이 서비스 이용을 해지하고자 하는 경우 가입한 서비스 별로 해지(회원탈퇴)신청을 하여야 합니다.<br></br>
제휴 서비스는 해당 서비스의 회원 정보를 이용하여 제공되는 서비스이므로,회원이 각 제휴 서비스의 회원자격을 상실하거나 탈퇴 시 정상적으로 서비스의 제공이 이루어지지 않을 수 있습니다.<br></br>
설치된 애플리케이션을 삭제할 경우, 회원의 계정 정보가 삭제되는 경우가 있을 수 있으므로 사전에 확인 후 삭제하시기 바랍니다.<br></br>

(제14조) 서비스의 변경 및 중단<br></br>
회사는 원활한 애플리케이션서비스 제공을 위해 운영 상 또는 기술상의 필요에 따라 서비스를 변경할 수 있으며,변경 전에 해당 내용을 애플리케이션 서비스 내에 공지합니다.<br></br>
다만, 버그/오류 등의 수정이나 긴급 업데이트 등 부득이하게 변경할 필요가 있는 경우 또는 중대한 변경에 해당하지 않는 경우에는 사후에 공지할 수 있습니다.<br></br>
회사는 영업,분할,합병 등에 따른 영업의 폐지,애플리케이션제공의 계약만료로 인한 애플리케이션 서비스의 현저한 수익 악화 등 경영상의 중대한 사유로 애플리케이션 서비스를 지속하기 어려운 경우에는 서비스를 전부를 중단할 수 있습니다.<br></br>
이 경우 중단일자 30일 이전까지 중단일자,중단사유,보상조건 등을 애플리케이션 애플리케이션 초기화면 또는 그 연결화면을 통해 공지하고 제 29조 제 1항에 따라 회원에게 통지합니다.<br></br>
제 2항의 경우 회사는 사용하지 않았거나 사용기간이 남아 있는 유료 아이템에 대해 제 26조 제 3항에 따라 환급합니다.<br></br><br></br>

(제15조) 정보의 수집 등<br></br>
회사는 회원 간에 이루어지는 채팅 내용을 저장•보관할 수 있으며 이 정보는 회사만이 보유합니다.<br></br>
회사는 회원 간의 분쟁 조정,민원 처리 또는 애플리케이션질서의 유지를 위한 경우에 한하여,제 3자는 법령에 따라 권한이 부여된 경우에 한하여 이 정보를 열람할 수 있습니다.<br></br>
회사 또는 제 3자가 제 1항에 따라 채팅 정보를 열람할 경우회사는 사전에 열람의 사유 및 범위를 해당 회원에게 고지합니다.<br></br>
다만,제 10조 제 1항에 따른 금지행위의 조사•처리•확인 또는 그 행위로 인한 피해 구제와 관련하여 이 정보를 열람해야 할 경우에는 사후에 고지할 수 있습니다.<br></br>
회사는 서비스의 원활하고 안정적인 운영 및 서비스 품질의 개선을 위하여 회원의 개인정보를 제외한 회원의 모바일 기기 정보(설정,사양,운영체제,버전 등)를 수집•활용할 수 있습니다.<br></br>
회사는 서비스 개선 및 회원 대상 서비스 소개 등을 위한 목적으로 회원에게 추가정보를 요청할 수 있습니다.<br></br>
이 요청에 대해 회원은 승낙하거나 거절할 수 있으며,회사가 이 요청을 할 경우에는 회원이 이 요청을 거절할 수 있다는 뜻을 함께 고지합니다.<br></br><br></br>

(제16조) 광고의 제공<br></br>
회사는 서비스의 운영과 관련하여 애플리케이션 서비스 내에 광고를 게재할 수 있습니다. 또한 수신에 동의한 회원에 한하여 전자우편,문자서비스(LMS/SMS), 푸시메세지(Push Notification) 등의 방법으로 광고성 정보를 전송할 수 있습니다.이 경우 회원은 언제든지 수신을 거절할 수 있으며,회사는 회원의 수신 거절 시 광고성 정보를 발송하지 아니합니다.<br></br>
회사가 제공하는 서비스 중의 배너 또는 링크 등을 통해 타인이 제공하는 광고나 서비스 중의 배너 또는 링크 등을 통해 타인이 제공하는 광고나 서비스에 연결될 수 있습니다.<br></br>
제 2항에 따라 타인이 제공하는 광고나 서비스에 연결될 경우 해당 영역에서 제공하는 서비스는 회사의 서비스 영역이 아니므로 회사가 신뢰성,안정성 등을 보장하지 않으며,<br></br>
그로 인한 회원의 손해에 대하여도 회사는 책임을 지지 않습니다.다만 ,회사가 고의 또는 중과실로 손해의 발생을 용이하게 하거나,손해 방지를 위한 조치를 취하지 아니한 경우에는 그러지 아니합니다.<br></br><br></br>

(제17조) 저작권 등의 귀속<br></br>
회사가 제작한 애플리케이션 서비스 내의 콘텐츠에 대한 저작권과 기타 지적재산권은 회사에 귀속됩니다.<br></br>
회원은 회사가 제공하는 애플리케이션 서비스를 이용하여 얻은 정보 중에서 회사 또는 제공업체에 지적재산권이 귀속된 정보를<br></br>
회사 또는 제공업체의 사전 동의 없이 복제 전송 등의 방법 (편집,공표,공연,배포,방송 2차적 저작물 작성 등을 포함합니다. 이하 같습니다)에 의하여 영리목적으로 이용하거나 타인에게 이용하게 하여서는 안 됩니다.<br></br>
회원은 애플리케이션 내에서 보여지거나 애플리케이션 서비스와 관련한 회원 또는 다른 이용자가 애플리케이션 애플리케이션 또는 애플리케이션 서비스를 통해 업로드<br></br>
또는 전송하는 대화 텍스트를 포함한 커뮤니케이션,이미지,사운드 및 모든 자료 및 정보(이하 “이용자콘텐츠”라 합니다.)에 대하여 회사가 다음과 같은 방법과 조건으로 이용하는 것을 허락합니다.<br></br>
- 해당 이용자 콘텐츠를 이용,편집 형식의 변경 및 기타 변형하는 것 (공표, 복제,공연,전송,배포,방송, 2차적 저작물 작성 등 어떠한 형태로든 이용 가능하며,이용 기간과 지역에는 제한이 없음)<br></br>
- 이용자 콘텐츠를 제작한 이용자의 사전 동의 없이 거래를 목적으로 이용자 콘텐츠를 판매,대여,양도 행위를 하지 않음<br></br>
애플리케이션 내에서 보여지지 않고 애플리케이션 서비스와 일체화되지 않은 회원의 이용자 콘텐츠(예컨대,일반게시판 등에서의 게시물)에 대하여<br></br>
회사는 회원의 명시적인 동의가 없어 이용하지 않으며,회원은 언제든지 이러한 이용자 콘텐츠를 삭제할 수 있습니다.<br></br>
회사는 회원이 게시하거나 등록하는 서비스 내의 게시물에 대해 제 10조 제 1항에 따른 금지행위에 해당된다고 판단되는 경우에는<br></br>
사전 통지 없이 이를 삭제 또는 이동하거나 그 등록을 거절할 수 있습니다.<br></br>
회사가 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 회원은 회사에 해당 정보의 삭제 또는 반박 내용의 게재를 요청할 수 있습니다.<br></br>
이 경우 회사는 신속하게 필요한 조치를 취하고이를 신청인에게 통지합니다.<br></br>
이 조는 회사가 애플리케이션 서비스를 운영하는 동안 유효하며,회원 탈퇴 후에도 지속적으로 적용됩니다.<br></br><br></br>

(제19조) 유료 컨텐츠의 구매사용 기간 및 이용<br></br>
애플리케이션 서비스 내에서 회원이 구매한 유료 콘텐츠는 구매하신 계정에서만 사용하실 수 있습니다.<br></br>
회원이 구매한 유료 콘텐츠의 이용기간은 구매 시 명시된 기간에 따릅니다.<br></br>
다만 제 15조 2항에 따라 서비스 중단이 이루어지는 경우 기간의 정함이 없는 유료 콘텐츠의 이용기간은 서비스 중단 공지 시 공지된 서비스의 중단일자까지로 합니다.<br></br>
서비스 내에 다른 콘텐츠로의 교환이나,콘텐츠 이용 시 소모되는 콘텐츠(이하”애플리케이션 재화”라 합니다)의 경우 유료 결제를 통해 제공되거나,<br></br>
서비스 이용에 따라 무상으로 제공될 수 있습니다.<br></br>
애플리케이션 재화는 사용 시 유료결제를 통해 제공된 것이 우선적으로 사용됩니다.<br></br>
다만,서비스에서 별도의 사용 우선순위를 지정한 경우에는 그러지 아니합니다.<br></br><br></br>

(제20조) 회원에 대한 서비스 이용제한<br></br>
회원은 제 10조에 따른 회원의 의무를 위반하는 행위를 하여서는 안 되며,해당 행위를 하는 경우에<br></br>
회사는 다음 각 호의 구분에 따른 회원의 서비스 이용제한,관련정보(글,사진,영상 등)삭제 및 기타의 조치를 포함한 이용제한 조치를 할 수 있습니다.<br></br>
이용제한 조치가 이루어지는 구체적인 사유 및 절차는 제 21조 1항에 따라 개별 애플리케이션의 운영정책에서 정합니다.<br></br>
① 일부 권한 제한:일정기간 채팅 등 일정 권한을 제한<br></br>
② 캐릭터 이용제한:일정기간 또는 영구히 회원 캐릭터의 이용을 제한<br></br>
③ 계정 이용제한:일정기간 또는 영구히 회원 계정의 이용을 제한<br></br>
④ 회원 이용제한: 일정기간 또는 영구히 회원의 애플리케이션 서비스 이용을 제한<br></br>
제 1항의 이용제한이 정당한 경우에는 회사는 이용제한으로 인하여 회원이 입은 손해를 배상하지 않습니다.<br></br>
회사는 다음 각 호의 사유에 대한 조사가 완료될 때까지 해당 계정의 서비스 이용을 정지할 수 있습니다.<br></br>
① 계정이 해킹 또는 도용당했다는 정당한 신고가 접수된 경우<br></br>
② 불법프로그램 사용자 또는 작업장 등 위법행위자로 의심되는 경우<br></br>
③ 그 밖에 각 호에 준하는 사유로 서비스 이용의 잠정조치가 필요한 경우<br></br>
제 3항의 조사가 완료된 후,유료 애플리케이션 서비스의 경우에는 정지된 시간만큼 회원의 이용시간을 연장하거나 그에 상당하는 유료 서비스 또는 캐시 등으로 보상합니다.<br></br>
다만,회원이 제 3항 각 호의 사유에 해당하는 경우에는 그러하지 아니합니다.<br></br><br></br>

(제21조) 이용제한 조치의 사유와 절차<br></br>
회사는 제 20조 제 1항에 따른 이용제한 조치의 구체적인 사유 및 절차를 제 10조 1항에 따른 금지행위의 내용,정도,횟수,결과 등을 고려하여 운영정책으로 정합니다.<br></br>
회사가 제 20조 1항에서 정한 이용제한 조치를 하는 경우에는 다음 각 호의 사항을 회원에게 사전 통지합니다.다만,긴급히 조치할 필요가 있는 경우에는 사후에 통지할 수 있습니다.<br></br>
① 이용제한 조치의 사유<br></br>
② 이용제한 조치의 유형 및 기간<br></br>
③ 이용제한 조치에 대한 이의신청 방법<br></br><br></br>

(제22조) 이용제한 조치에 대한 이의신청 절차<br></br>
회원이 회사의 이용제한 조치에 불복하고자 할 때에는 이 조치의 통지를 받은 날부터 14일 이내에 불복 이유를 기재한 이의 신청서를 서면,전자우편 또는 이에 준하는 방법으로 회사에 제출하여야 합니다.<br></br>
회사는 제 1항의 이의신청서를 접수한 날로부터 15일 이내에 불복 이유에 대하여 서면,전자우편 또는 이에 준하는 방법으로 답변합니다.<br></br>
다만,회사는 이 기간 내에 답변이 어려운 경우에는 그 사유와 처리 일정을 통지합니다.<br></br>
회사는 불복 이유가 타당한 경우에는 이에 따른 조치를 취합니다.<br></br><br></br>

(제23조) 대금결제<br></br>
콘텐츠에 대한 구매 대금의 부과와 납부는 원칙적으로 이동통신사나 오픈마켓 사업자 등에서 정하는 정책이나 방법에 따릅니다.<br></br>
또한 각 결제수단별 한도가 회사나 오픈마켓 사업자가 정하는 정책 또는 정부의 방침에 따라 부여되거나 조정될 수 있습니다.<br></br>
콘텐츠의 구매대금을 외화로 결제하는 경우에는 환율,수수료 등으로 인하여 실제 청구금액이 서비스의 상점 등에서 표시된 가격과 달라질 수 있습니다.<br></br><br></br>

(제24조) 청약 철회 등<br></br>
회사와 유료 콘텐츠의 구매에 관한 계약을 체결한 회원은 구매계약일과 콘텐츠 이용 가능일 중 늦은 날부터 7일 이내에 별도의 수수료,위약금 등의 부담없이 청약철회를 할 수 있습니다.<br></br>
회원은 다음 각 호에 해당하는 경우에는 회사의 의사에 반하여 제 1항에 따른 청약철회를 할 수 없습니다.<br></br>
다만, 가분적 콘텐츠로 구성된 구매계약의 경우에는 가분적 콘텐츠 중 다음 각 호에 해당하지 아니하는 나머지 부분에 대하여는 그러지 아니합니다.<br></br>
① 구매 즉시 사용되거나 적용되는 유료 콘텐츠<br></br>
② 추가 혜택이 제공되는 경우에 그 추가 혜택이 사용된 콘텐츠<br></br>
③ 개봉행위를 사용으로 볼 수 있거나 개봉 시 효용이 결정되는 콘텐츠의 개봉행위가 있는 경우<br></br>
회사는 제 2항 각 호의 규정에 따라 청약철회가 불가능한 콘텐츠의 경우에는 그 사실을 회원이 쉽게 알 수 있는 곳에 명확하게 표시하고,<br></br>
해당 콘텐츠의 시험 사용 상품을 제공(한시적 이용의 허용,체험용 제공 등)하거나<br></br>
이에 대한 제공이 곤란한 경우에는 콘텐츠에 관한 정보 제공함으로써 회원의 청약철회의 권리행사가 방해 받지 아니하도록 조치합니다.<br></br>
만약 회사가 이러한 조치를 하지 아니한 경우에는 제 2항 각 호의 청약철회 제한사유에도 불구하고 회원은 청약철회를 할 수 있습니다.<br></br>
회원은 제 1항 및 제 2항에도 불구하고 구매한 유료 콘텐츠의 내용이 표시.광고의 내용과 다르거나 구매계약의 내용과 다르게 이행된 경우에<br></br>
해당 콘텐츠가 이용 가능하게 된 날부터 3개월 이내,그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회를 할 수 있습니다.<br></br>
회원이 청약철회를 할 경우 회사는 플랫폼사업자 또는 오픈 마켓 사업자를 통해 구매내역을 확인합니다.<br></br>
또한 회사는 회원의 정당한 철회 사유를 확인하기 위해 회원에게서 제공받은 정보를 통해 회원에게 연락할 수 있으며,추가적인 증빙을 요구할 수 있습니다.<br></br>
제 1항부터 4항까지의 규정에 따라 청약철회가 이루어질 경우 회사는 지체 없이 회원의 유료 콘텐츠를 회수하고 3영업일 이내에 대금을 환급합니다.<br></br>
이 경우 회사가 환급을 지연할 때에는 그 지연기간에 대하여 『전자상거래 등에서의 소비자보호에 관한 법률』, 및 같은 법 시행령 제 21조의 3에서 정하는 이율을 곱하여 산정한 지연이자를 지급합니다.<br></br><br></br>

(제25조) 과오납금의 환급<br></br>
회사는 과오납금이 발생하는 경우 과오납금을 회원에게 환급합니다.<br></br>
다만, 과오납금이 회사의 고의 또는 과실없이 회원의 과실로 인하여 발생한 경우에는 그 환급에 소요되는 실제 비용은 합리적인 범위 내에서 회원이 부담합니다.<br></br>
애플리케이션을 통한 결제는 오픈마켓 사업자가 제공하는 결제방식에 따르며,결제 과정에서 과오납금이 발생하는 경우,회사 또는 오픈마켓 사업자에게 환급을 요청하여야 합니다.<br></br>
애플리케이션의 다운로드 또는 네트워크 서비스의 이용으로 인해 발생한 통신요금 (통화료,데이터 통화료 등)은 환급 대상에서 제외될 수 있습니다.<br></br>
환급은 서비스 이용하고 있는 모바일 기기의 운영체제 종류에 따라 각 오픈마켓 사업자 또는 회사의 환급정책에 따라 진행됩니다.<br></br>
회사는 과오납금의 환급을 처리하기 위해 회원에게 제공받은 정보를 통해 회원에게 연락할 수 있으며,필요한 정보의 제공을 요청할 수 있습니다.<br></br>
회사는 회원으로부터 환급에 필요한 정보를 받은 날부터 3영업일 이내에 환급합니다.<br></br><br></br>

(제26조) 계약 해지<br></br>
회원은 언제든지 서비스 이용을 원하지 않는 경우 회원 탈퇴를 통해 이용계약을 해지할 수 있습니다.<br></br>
회원탈퇴로 인해 회원이 애플리케이션 서비스 내에서 보유한 애플리케이션 이용정보(재화,캐릭터,아이템 등)는 모두 삭제되어 복구가 불가능하게 됩니다.<br></br>
회사는 회원이 이 약관 및 그에 따른 운영정책,서비스 정책에서 금지하는 행위를 하는 등 본 계약을 유지할 수 없는 중대한 사유가 있는 경우에는<br></br>
상당한 기간 전에 최고하고 기간을 정하여 서비스 이용을 중지하거나 이용계약을 해지할 수 있습니다.<br></br>
제 1항 및 제 2항에 따른 환급 및 손해배상은 『콘텐츠이용자보호지침』에 따라 처리합니다.<br></br>
회사는 최근의 서비스 이용일부터 연속하여 1년동안 회사의 서비스를 이용하지 않은 회원(“휴면계정”이라 합니다)의 개인정보를 보호하기 위해<br></br>
이용계약을 해지하고 회원의 개인정보 파기 등의 조치를 취할 수 있습니다.<br></br>
이 경우 조치일 30일 전까지 계약해지,개인정보 파기 등의 조치가 취해진다는 사실 및 파기될 개인정보 등을 회원에게 통지합니다.<br></br><br></br>

(제27조) 손해 배상<br></br>
회사 또는 회원은 본 약관을 위반하여 상대방에게 손해를 입힌 경우에는 그 손해를 배상할 책임이 있습니다.다만,고의 또는 과실이 없는 경우에는 그러하지 아니합니다.<br></br>
회사가 개별 서비스 제공자와 제휴 계약을 맺고 회원에게 개별 서비스를 제공하는 경우에 회원이 이 개별 서비스 이용약관에 동의를 한 뒤<br></br>
개별 서비스 제공자의 고의 또는 과실로 인해 회원에게 손해가 발생한 경우에 그 손해에 대해서는 개별 서비스는 제공자가 책임을 집니다.<br></br><br></br>

(제28조) 회사의 면책<br></br>
회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관하여 책임을 지지 않습니다.<br></br>
회사는 서비스용 설비의 보수,교체,정기점검,공사 등 기타 이에 준하는 사유로 발생한 손해에 대하여 책임을 지지 않습니다.다만,회사의 고의 또는 과실에 의한 경우에는 그러지 아니합니다.<br></br>
회사는 회원의 고의 또는 과실로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다. 다만,회원에게 부득이하거나 정당한 사유가 있는 경우에는 그러하지 아니합니다.<br></br>
회원이 서비스와 관련하여 게재한 정보나 자료 등의 신뢰성,정확성 등에 대하여 회사는 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.<br></br>
회사는 회원이 다른 회원 또는 타인과 서비스를 매개로 발생한 거래나 분쟁에 대해 개입할 의무가 없으며,이로 인한 손해에 대해 책임을 지지 않습니다.<br></br>
회사는 무료로 제공되는 서비스 이용과 관련하여 회원에게 발생한 손해에 대해서는 책임을 지지 않습니다.<br></br>
그러나 회사의 고의 또는 중과실에 의한 경우에는 그러하지 아니합니다.<br></br>
회사는 회원이 서비스를 이용하여 기대하는 이익을 얻지 못하거나 상실한 것에 대하여 책임을 지지 않습니다.<br></br>
회사는 회원의 애플리케이션상 경험치, 등급,아이템,애플리케이션 머니 등의 손실에 대하여 책임을 지지 않습니다.<br></br>
다만,회사의 고의 또는 과실에 의한 경우에는 그러하지 아니합니다.<br></br>
회사는 회원이 모바일 기기 비밀번호,오픈마켓 사업자가 제공하는 비밀번호 등을 관리하지 않아 발생하는 제 3자 결제에 대해 책임을 지지 않습니다.<br></br>
다만,회사의 고의 또는 과실에 의한 경우에는 그러하지 아니합니다.<br></br>
회원이 모바일 기기의 변경,모바일 기기의 번호 변경,운영체재(OS) 버전의 변경,해외 로밍,통신사 변경 등으로 인해 콘텐츠 전부나 일부의 기능을 이용할 수 없는 경우 회사는 이에 대해 책임을 지지 않습니다.<br></br>
다만,회사의 고의 또는 과실에 의한 경우에는 그러하지 아니합니다.<br></br>
회원이 회사가 제공하는 콘텐츠나 계정정보를 삭제한 경우 회사는 이에 대해 책임을 지지 않습니다.다만,회사의 고의 또는 과실에 의한 경우에는 그러하지 아니합니다.<br></br>
회사는 임시회원이 서비스 이용으로 발생한 손해에 대해서는 책임을 지지 않습니다.다만,회사의 고의 또는 과실에 의한 경우에는 그러하지 아니합니다.<br></br><br></br>

(제29조) 회원에 대한 통지<br></br>
회사가 회원에게 통지하는 경우 회원의 전자우편주소,전자메모,애플리케이션 서비스 내 쪽지, 문제 메시지 (LMS/SMS)등으로 할 수 있습니다.<br></br>
회사는 회원 전체에게 통지를 하는 경우 7일 이상 애플리케이션 서비스 내에 게시하거나 팝업화면 등을 제시함으로써 제 1항의 통지에 갈음할 수 있습니다.<br></br><br></br>

(제30조) 재판권 및 준거법<br></br>
이 약관은 대한민국 법률에 따라 규율되고, 해석됩니다.회사와 회원 간에 발생한 분쟁으로 소송이 제기되는 경우에는 회사의 본사 소재지를 관할하는 법원의 전속관할로 합니다.<br></br><br></br>

(제31조) 회원의 고충 처리 및 분쟁해결<br></br>
회사는 회원의 편의를 고려하여 회원의 의견이나 불만을 제시하는 방법을 애플리케이션 서비스 내에 또는 그 연결화면에 안내합니다. 회사는 이러한 회원의 의견이나 불만을 처리하기 위한 전담인력을 운영합니다.<br></br>
회사는 회원으로부터 제기되는 의견이나 불만을 정당하다고 객관적으로 인정될 경우에는 합리적인 기간 내에 이를 신속하게 처리합니다.<br></br>
다만,처리에 장기간이 소요되는 경우에는 회원에게 장기간이 소요되는 사유와 처리일정을 애플리케이션 서비스 내 공지하거나 제 29조 1항에 다라 통지합니다.<br></br>
회사와 회원 간에 분쟁이 발생하여 제 3의 분쟁조정기관이 조정할 경우 회사는 이용제한 등 회원에게 조치한 사항을 성실히 증명하고,조정기관의 조정에 따를 수 있습니다.<br></br><br></br>

부칙<br></br>
본 약관은 2025년 2월 14일부터 시행됩니다.

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceCenterModal;